import type { RouteRecordRaw } from 'vue-router';
export const portalRoutes: RouteRecordRaw[] = [
  {
    path: 'portal/access',
    name: 'portal-access',
    component: () => import('../pages/portal/PortalAccessPage.vue'),
    meta: { requiresModule: 'portal' },
  },
];
